// Delegation also covers cards inserted by filtering, pagination and menus.
(() => {
  const desktop = window.matchMedia('(min-width: 1024px)');
  function prepare(event) {
    if (!desktop.matches || event.pointerType === 'touch') return;
    const card = event.target.closest('[data-deferred-hover]');
    const picture = card?.querySelector('[data-hover-picture]');
    const source = picture?.querySelector('[data-hover-srcset]');
    if (!source || card.dataset.hoverLoading === 'true') return;
    const image = picture.querySelector('img');
    card.dataset.hoverLoading = 'true';
    const done = () => {
      image.removeEventListener('load', loaded);
      image.removeEventListener('error', failed);
      delete card.dataset.hoverLoading;
    };
    const loaded = () => {
      // The placeholder can finish after listeners attach. Wait for a real image.
      if (!image.currentSrc || image.currentSrc.startsWith('data:') || !image.naturalWidth) return;
      card.dataset.hoverReady = 'true';
      source.removeAttribute('data-hover-srcset');
      done();
    };
    const failed = () => {
      source.removeAttribute('srcset');
      done(); // Keep the primary visible and permit a later retry.
    };
    image.addEventListener('load', loaded);
    image.addEventListener('error', failed);
    image.loading = 'eager';
    source.setAttribute('srcset', source.getAttribute('data-hover-srcset'));
    if (image.complete) loaded();
  }
  document.addEventListener('pointerover', prepare);
  document.addEventListener('focusin', prepare);
})();
